import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users } from "lucide-react";

/** Holder count + 14-day sparkline (refreshed on-chain every 6h). */
export default function HoldersStrip({ slug }) {
  const [h, setH] = useState(null);
  useEffect(() => {
    api.get(`/coins/${slug}/holders`).then((r) => setH(r.data)).catch(() => {});
  }, [slug]);
  if (!h || !h.minted || h.holders == null) return null;

  const pts = h.history.map((x) => x.holders);
  const max = Math.max(1, ...pts);
  const min = Math.min(...pts);
  const W = 120, H = 28;
  const path = pts
    .map((v, i) => `${i === 0 ? "M" : "L"}${(i / Math.max(1, pts.length - 1)) * W},${H - ((v - min) / Math.max(1, max - min)) * (H - 4) - 2}`)
    .join(" ");

  return (
    <div className="px-5 py-3 border-t border-[#3a3a3a] flex items-center justify-between gap-4 flex-wrap" data-testid="holders-strip">
      <div className="flex items-center gap-2 font-mono text-xs">
        <Users size={12} className="text-[#cfff04]" />
        <span className="text-white" data-testid="holders-count">{Number(h.holders).toLocaleString()}</span>
        <span className="text-[#d0d0d0] uppercase tracking-widest text-[11px]">holders</span>
        {h.delta !== 0 && (
          <span className={`text-[11px] ${h.delta > 0 ? "text-[#00ff41]" : "text-[#ff3333]"}`} data-testid="holders-delta">
            {h.delta > 0 ? "▲" : "▼"} {Math.abs(h.delta)} today
          </span>
        )}
      </div>
      {pts.length >= 2 && (
        <svg width={W} height={H} className="text-[#cfff04]" data-testid="holders-spark">
          <path d={path} fill="none" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      )}
    </div>
  );
}
